/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareLeftIcon24Solid = forwardRef('RotateSquareLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.638.292a1.125 1.125 0 0 1 1.424 1.741l-.723.592h2.911a5.125 5.125 0 0 1 5.125 5.125V11a1.125 1.125 0 0 1-2.25 0V7.75a2.875 2.875 0 0 0-2.875-2.875h-2.91l.722.592a1.125 1.125 0 0 1-1.424 1.741L11.42 5.395a2.125 2.125 0 0 1 0-3.29L13.638.292Z" }),
        React.createElement("path", { d: "M18 13a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-6Z" })));
});
